<template>
    <div :class="textboxGroupClass()">
        <input  :class="textboxControlClass()" 
                type="text"
                :id="textbox.id" 
                :name="textbox.name" 
                :placeholder="textbox.placeholder"
                :aria-describedby="textbox.id+'-help'" 
                v-validate="textbox.veeRules" 
                data-vv-delay="700"
                v-model="textbox.value">
        <div class="textbox-errors" v-show="errors.has(textbox.name)">{{ errors.first(textbox.name) }}</div>
        <small v-if="textbox.helpText" :id="textbox.id+'-help'" class="input-help-text">{{ textbox.helpText }}</small>
    </div>
</template>
<script>

export default {
  name: 'text-input',
  inject: ['$validator'], //Required to allow validation to run properly from parent
  props: {
    textbox: {
        type: Object,
        default: function () {
          return {
            id: 'textDefault',
            class: 'text-input-default',
            name: 'textDefault',
            placeholder: 'Enter text...',
            helpText: '',
            veeRules: 'required|alpha',
            value: ''
          }
        }
      }
  },
  methods: {
    textboxGroupClass: function() {
        var result = [];
        result.push(this.textbox.class);
        if(this.errors.has(this.textbox.name)){
            result.push('has-warning')
        }
        if(!this.errors.has(this.textbox.name) && this.isFormDirty) {
            result.push('has-success')
        }
        return result;
    },
    textboxControlClass: function() {
        var result = [];
        if(this.errors.has(this.textbox.name))
            result.push('input-warning')
        if(!this.errors.has(this.textbox.name))
            result.push('input-success')
        return result;
    },
    
    
  },
  computed: {
    /*
    isFormDirty() {
      return Object.keys(this.fields).some(key => this.fields[key].dirty);
    }*/
  }
}
</script>

<style>
input{
    background: #ECECEC;
    color: #333;
    border-color: #ECECEC; 
    font-weight: bold;
}

input::placeholder{
    color: #999;
}

input:focus {
    outline: none;
    color: #333;
    border-color: #DDDDDD;
}

.textbox-errors{
    font-size: 14px;
    line-height: 16px;
    font-weight: 400;
    margin-top: 6px;
    margin-left: 20px;
    color: red;
}

.input-warning{
    border-color: #FF0000;
}

.input-success{
    border-color: #53CF99;
}

</style>

